<app-header />

@if (isLoading) {
  <div class="max-w-7xl mx-auto px-6 py-20 text-center">
    <p class="text-gray-600">Cargando...</p>
  </div>
} @else if (error || !event || !subevento) {
  <div class="max-w-7xl mx-auto px-6 py-20 text-center">
    <h2 class="text-2xl font-bold text-gray-800 mb-4">No se pudo cargar</h2>
    <p class="text-gray-600 mb-6">El recurso que buscas no está disponible.</p>
    <button
      (click)="goBackToEvent()"
      class="bg-[#e8343f] text-white px-6 py-3 rounded-lg hover:bg-red-700 transition-colors"
    >
      Volver al inicio
    </button>
  </div>
} @else {

  <!-- Banner -->
  <section class="border-b border-gray-300">
    <div class="max-w-7xl mx-auto px-6 pt-2 pb-4">
      <div class="aspect-[40/21] bg-gray-100 border border-gray-300 overflow-hidden rounded-2xl relative">
        <img
          [src]="getBannerImage()"
          [alt]="subevento.nombre"
          class="w-full h-full object-cover"
        />
        <div class="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end p-8">
          <div>
            <!-- Breadcrumb -->
            <nav class="flex items-center text-white/80 text-sm mb-3 flex-wrap gap-1">
              <button (click)="goBackToEvent()" class="hover:text-white transition-colors">{{ event.nombre }}</button>
              <svg class="w-4 h-4 mx-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
              </svg>
              <button (click)="goBackToVagones()" class="hover:text-white transition-colors">{{ subevento.nombre }}</button>
              <svg class="w-4 h-4 mx-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
              </svg>
              <button (click)="goBackToVagones()" class="hover:text-white transition-colors">Selección de vagón</button>
              <svg class="w-4 h-4 mx-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
              </svg>
              <span class="text-white font-semibold">Comprar</span>
            </nav>
            <h1 class="text-3xl md:text-4xl font-bold text-white">{{ subevento.nombre }}</h1>
            <p class="text-white/90 mt-1 capitalize">{{ formatFecha(fecha) }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Contenido -->
  <section class="py-10">
    <div class="max-w-7xl mx-auto px-6">

      @if (event.tipoevento === 'tren') {
        <!-- Navegación por niveles (tipo tren) -->
        <div class="mb-8 space-y-4">
          <!-- Botones de navegación -->
          <div class="flex items-center gap-3 flex-wrap">
            <button
              (click)="goBackToActividad()"
              class="flex items-center gap-2 bg-[#e8343f] text-white px-5 py-3 rounded-xl text-base font-bold hover:bg-red-700 transition-colors shadow-md"
            >
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
              </svg>
              Cambiar fecha
            </button>
            <button
              (click)="goBackToVagones()"
              class="flex items-center gap-2 bg-[#e8343f] text-white px-5 py-3 rounded-xl text-base font-bold hover:bg-red-700 transition-colors shadow-md"
            >
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
              </svg>
              Cambiar coche
            </button>
          </div>

          <!-- Resumen de selección -->
          <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div class="bg-white rounded-xl border-2 border-gray-200 p-5 flex items-center gap-4">
              <div class="bg-red-50 rounded-full w-14 h-14 flex items-center justify-center shrink-0">
                <svg class="w-7 h-7 text-[#e8343f]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                </svg>
              </div>
              <div>
                <p class="text-sm text-gray-500">Fecha</p>
                <p class="text-xl font-bold text-gray-900 capitalize">{{ formatFecha(fecha) }}</p>
              </div>
            </div>
            @if (hora) {
              <div class="bg-white rounded-xl border-2 border-gray-200 p-5 flex items-center gap-4">
                <div class="bg-red-50 rounded-full w-14 h-14 flex items-center justify-center shrink-0">
                  <svg class="w-7 h-7 text-[#e8343f]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                </div>
                <div>
                  <p class="text-sm text-gray-500">Horario</p>
                  <p class="text-xl font-bold text-gray-900">{{ hora }}</p>
                </div>
              </div>
            }
            @if (tipoticket) {
              <div class="bg-white rounded-xl border-2 border-[#e8343f] p-5 flex items-center gap-4">
                <div class="bg-red-50 rounded-full w-14 h-14 flex items-center justify-center shrink-0">
                  <svg class="w-7 h-7 text-[#e8343f]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
                  </svg>
                </div>
                <div>
                  <p class="text-sm text-gray-500">Coche</p>
                  <p class="text-xl font-bold text-[#e8343f]">{{ tipoticket.nombre_localidad }}</p>
                </div>
              </div>
            }
          </div>

          <!-- Título del paso -->
          <div class="flex items-center gap-3">
            <span class="bg-[#e8343f] text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold">3</span>
            <div>
              <h2 class="text-2xl font-bold text-gray-900">Selecciona tus entradas</h2>
              <p class="text-gray-500 text-sm">Elige tus asientos o la cantidad de entradas.</p>
            </div>
          </div>
        </div>
      } @else {
        <!-- Botón volver simple (otros tipos de evento) -->
        <div class="mb-6">
          <button
            (click)="goBackToVagones()"
            class="flex items-center text-gray-600 hover:text-[#e8343f] transition-colors"
          >
            <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
            </svg>
            Volver a selección de vagón
          </button>
        </div>
      }

      <!-- Mensaje de no disponibilidad -->
      @if (isExpired) {
        <div class="mb-6 bg-red-50 border-2 border-red-200 rounded-xl p-6">
          <div class="flex items-start gap-4">
            <div class="bg-red-100 rounded-full w-12 h-12 flex items-center justify-center shrink-0">
              <svg class="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
            </div>
            <div class="flex-1">
              <h3 class="text-lg font-bold text-red-900 mb-1">Venta web no disponible</h3>
              <p class="text-red-700 mb-3">{{ expirationMessage }}</p>
              <p class="text-red-600 text-sm">
                Para adquirir entradas, por favor contacta directamente con nuestras oficinas o taquillas.
              </p>
              <button
                (click)="goBackToActividad()"
                class="mt-4 flex items-center gap-2 bg-red-600 text-white px-5 py-2.5 rounded-lg text-sm font-semibold hover:bg-red-700 transition-colors"
              >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
                </svg>
                Elegir otra función
              </button>
            </div>
          </div>
        </div>
      }

      <!-- Selectores de tickets (solo si no está expirado) -->
      @if (!isExpired) {
        @if (tipoticket?.seatmapid) {
          <app-ticket-selector-tren
            [eventoid]="event.eventoid"
            [url_slug]="event.url_slug"
            [event]="event"
            [directTipoTicketId]="tipoticketid"
            (ticketsAdded)="onTicketsAdded()"
          />
        } @else {
          <app-ticket-selector
            [eventoid]="event.eventoid"
            [preloadedTipoTickets]="tipoticket ? [tipoticket] : []"
            [event]="event"
            [url_slug]="event.url_slug"
            (ticketsAdded)="onTicketsAdded()"
          />
        }
      }

    </div>
  </section>
}

<app-footer />
<app-scroll-to-top />
